import { Injectable } from '@angular/core';
import * as loglevel from 'loglevel';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private readonly logger = loglevel;

  constructor() {
    const defaultLevel: loglevel.LogLevelDesc = environment.production ? 'warn' : 'debug';
    const overrideLevel = localStorage.getItem('loglevel');

    if (overrideLevel) {
      const upper = overrideLevel.toUpperCase();
      if (upper in loglevel.levels) {
        this.logger.setLevel(overrideLevel as loglevel.LogLevelDesc);
      } else {
        this.logger.setLevel(defaultLevel);
      }
    } else {
      this.logger.setLevel(defaultLevel);
    }
  }

  public trace(message: string, ...args: unknown[]): void {
    this.logger.trace(message, ...args);
  }

  public debug(message: string, ...args: unknown[]): void {
    this.logger.debug(message, ...args);
  }

  public info(message: string, ...args: unknown[]): void {
    this.logger.info(message, ...args);
  }

  public warn(message: string, ...args: unknown[]): void {
    this.logger.warn(message, ...args);
  }

  public error(message: string, ...args: unknown[]): void {
    this.logger.error(message, ...args);
  }

  public setLevel(level: loglevel.LogLevelDesc): void {
    this.logger.setLevel(level);
    localStorage.setItem('loglevel', level.toString());
  }

  public getLevel(): number {
    return this.logger.getLevel();
  }
}
